import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';

import { LedgerMasterService } from '../../../services/index';

@Component({
    selector: 'add-edit-ledger-master-window',
    templateUrl: './addEditLedgerMaster.component.html'
})
export class AddEditLedgerMasterComponent implements OnInit {
    title: string;
    ledgerdata: any = {};
    @Output() ledgerLoadEvent = new EventEmitter();
    isLoading: boolean = false;

    constructor(
        private ledgerMasterService: LedgerMasterService,
        public snackBar: MdSnackBar,
        public bsModalRef: BsModalRef,
        public toasterService: ToasterService
    ) { }

    ngOnInit(): void {
        setTimeout(() => {
            $('#ledger_name').focus();
        }, 500);
    }

    get isViewMode(): boolean {
        return this.ledgerdata['mode'] === 'View';
    }

    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }

    onSaveLedger(): void {
        let that = this;
        this.isLoading = true;
        this.ledgerMasterService
            .updateLedgerMaster(this.ledgerdata)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    that.ledgerLoadEvent.emit();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    that.toasterService.pop(toast);
                }
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/ledgerMaster/addEditLedgerMaster.component.ts